import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Complete bidirectional mapping of all pages with dedicated language routes

// Complete bidirectional mapping of all pages with dedicated language routes
export const dedicatedLanguageRoutes: Record<string, { pt: string; en: string }> = {
  // Home
  "/": { pt: "/", en: "/en/" },
  "/en/": { pt: "/", en: "/en/" },
  "/en": { pt: "/", en: "/en/" },

  // Registration (Registo)
  "/registo-yango-motorista-maputo": { pt: "/registo-yango-motorista-maputo", en: "/en/yango-driver-registration-maputo" },
  "/en/yango-driver-registration-maputo": { pt: "/registo-yango-motorista-maputo", en: "/en/yango-driver-registration-maputo" },

  // Signup (Cadastro)
  "/cadastro-motorista-yango": { pt: "/cadastro-motorista-yango", en: "/en/yango-driver-signup" },
  "/en/yango-driver-signup": { pt: "/cadastro-motorista-yango", en: "/en/yango-driver-signup" },

  // Requirements (Requisitos)
  "/requisitos-motorista-yango": { pt: "/requisitos-motorista-yango", en: "/en/yango-driver-requirements" },
  "/en/yango-driver-requirements": { pt: "/requisitos-motorista-yango", en: "/en/yango-driver-requirements" },

  // Download
  "/baixar-yango-pro-maputo": { pt: "/baixar-yango-pro-maputo", en: "/en/download-yango-pro-maputo" },
  "/en/download-yango-pro-maputo": { pt: "/baixar-yango-pro-maputo", en: "/en/download-yango-pro-maputo" },

  // Automatic top-up (Recarga)
  "/recarga-automatica-yango-pro-emola-mpesa": { pt: "/recarga-automatica-yango-pro-emola-mpesa", en: "/en/automatic-top-up-yango-pro" },
  "/en/automatic-top-up-yango-pro": { pt: "/recarga-automatica-yango-pro-emola-mpesa", en: "/en/automatic-top-up-yango-pro" },

  // Blog
  "/blog": { pt: "/blog", en: "/en/blog" },
  "/en/blog": { pt: "/blog", en: "/en/blog" },

  // About
  "/sobre-nos": { pt: "/sobre-nos", en: "/en/about-us" },
  "/en/about-us": { pt: "/sobre-nos", en: "/en/about-us" },
};

export function getLanguageUrl(pathname: string, language: "pt" | "en"): string {
  // Check if this page has dedicated language routes
  const entry = dedicatedLanguageRoutes[pathname];
  if (entry) {
    return entry[language];
  }
  
  // Handle blog posts dynamically (PT blog posts stay in PT for both languages as there's no EN version)
  if (pathname.startsWith('/blog/')) {
    // PT blog posts don't have EN equivalents - keep same URL
    return pathname;
  }
  if (pathname.startsWith('/en/blog/')) {
    return language === "pt"
      ? pathname.replace('/en/blog/', '/blog/')
      : pathname;
  }
  
  // Fallback to home for unmapped routes
  return language === "en" ? "/en/" : "/";
}

/**
 * @deprecated Use getLanguageUrl instead for proper dedicated routes
 * This function generates URLs with ?lang= query params which is outdated
 */
export function buildUrlWithLang(path: string, lang: string): string {
  // Redirect to getLanguageUrl for proper dedicated routes
  return getLanguageUrl(path, lang as "pt" | "en");
}

// Helper to detect current language from pathname
export function detectLanguageFromPath(pathname: string): "pt" | "en" {
  return pathname.startsWith('/en') ? 'en' : 'pt';
}